import * as React from 'react';
import { createView, view, dynamic } from '@sail/engine';
import { css } from '@sail/ui';
import { copyTokens } from './tokens';
import { columnPaddingVariants } from './ColumnPaddingVariants';
import { helmTokens } from '../../theme';
export const CopyBodyLayout = createView(({ children, maxColumnCount, ...props })=>{
    return /*#__PURE__*/ React.createElement(view.div, {
        className: "CopyBody",
        ...props
    }, children);
}, {
    uses: [
        dynamic(({ maxColumnCount })=>{
            if (maxColumnCount !== undefined) {
                return [
                    css({
                        maxWidth: `calc(var(--columnMaxWidth) * ${maxColumnCount})`
                    })
                ];
            } else {
                return [
                    css({
                        maxWidth: 'var(--copyMaxWidth)'
                    })
                ];
            }
        })
    ],
    css: {
        paddingLeft: `${copyTokens.columnPaddingLeft}`,
        paddingRight: `${copyTokens.columnPaddingRight}`,
        font: 'body.large',
        color: 'text',
        letterSpacing: `${helmTokens.letterSpacing.large}`
    },
    variants: {
        ...columnPaddingVariants
    },
    defaults: {
        columnPaddingLeft: undefined,
        columnPaddingRight: undefined
    }
});

//# sourceMappingURL=CopyBodyLayout.js.map